<template>
  <div>
    <h1>{{ $t('gpt.label.publicUpload') }}</h1>
    <FileUpload :forPublicDoc="true" />
  </div>
</template>

<script>
import FileUpload from '@/components/forms/UploadGPTDocumentForm.vue';

export default {
    components: {
        FileUpload,
    },
};
</script>
<style scoped>
h1 {
  font-size: 1.5em;
  margin-left: 3em;
  color:#26384b;
}
</style>
